module.exports = __webpack_public_path__ + "static/media/vee.9ff35456.jpeg";